import React, { useState } from "react";

const HomeTutorContentGreen = () => {
  const [activeTab, setActiveTab] = useState(5); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <div>adf</div>;
      case 1:
        return <div>adfasdfasdfasdf</div>;
      case 2:
        return <div>asdf</div>;
      case 3:
        return <div>asdf</div>;
      case 4:
        return <div>asdf</div>;
      default:
        return null;
    }
  };
  return (
    <div className="w-[70%] mx-auto my-10">
      <div className="flex flex-row justify-between bg-green-800 w-full  rounded-lg ">
        <div className="p-10">
          <div>
            <h1 className="text-7xl font-signika  text-red-300">
              <span className="text-white">Unlock Your</span> <br></br>{" "}
              Potential with the <br></br>Tutor or Student Match
            </h1>
            <p className="text-xl font-signika text-red-300 mt-2">
              Connect with top-rated tutors and students, and manage your{" "}
              <br></br> tutoring engagements seamlessly. This is how modern
              education works.
            </p>
            <h1 className="text-2xl font-signika text-white mt-6">
              Manage Your Workflow Efficiently
            </h1>

            <h1 className="text-2xl font-signika text-white mt-2">
              Support Every Step of the Way
            </h1>
            <h1 className="text-2xl font-signika text-white mt-2">
              Expertise at Your Fingertips
            </h1>

            <button className="py-2 px-6 bg-white rounded-lg text-black font-roboto mt-5">
              Learn More
            </button>
          </div>
        </div>
        <div>
          <img
            className="w-[500px] h-[580px] rounded-r-lg"
            src="https://i.ibb.co.com/YBhSr1c/tutor1.jpg"
            alt=""
          ></img>
        </div>
      </div>
      <div className="relative my-10 h-[600px]">
        <img
          className="rounded-lg w-full h-full object-cover"
          src="https://i.ibb.co/dBKnR0V/73bd1ccc-0850-4ac4-9786-8dc58255c6fc.jpg"
          alt=""
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black to-green-600 opacity-90 rounded-lg"></div>

        {/* Text on top of the overlay */}
        <div className="absolute inset-0 flex flex-col justify-between items-start p-10">
          <h2 className="text-white text-6xl font-signika">Tuition Types</h2>
          <div className="grid grid-cols-2 gap-5 mt-5">
            <div className="p-5 rounded-lg border-2 border-green-200">
              <h1 className="text-3xl font-signika text-white">
                Home Tutoring
              </h1>
              <p className="text-lg font-signika text-green-200">
                Home tutoring allows students to learn various subjects in their
                own home.
              </p>
            </div>
            <div className="p-5 rounded-lg border-2 border-green-200">
              <h1 className="text-3xl font-signika text-white">
                Group Tutoring
              </h1>
              <p className="text-lg font-signika text-green-200">
                Group tutoring allows students to learn together and solve
                problems at an affordable cost.
              </p>
            </div>
            <div className="p-5 rounded-lg border-2 border-green-200">
              <h1 className="text-3xl font-signika text-white">
                Online Tutoring
              </h1>
              <p className="text-lg font-signika text-green-200">
                Find the best tutors from anywhere and take online classes by
                using tools such as Google Meet, Zoom, Skype, and more.
              </p>
            </div>
            <div className="p-5 rounded-lg border-2 border-green-200">
              <h1 className="text-3xl font-signika text-white">
                Package Tutoring
              </h1>
              <p className="text-lg font-signika text-green-200">
                Package tutoring helps a students to complete their studies
                within a specific time frame.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between gap-5 h-[600px]">
        <div className="w-[60%] flex flex-col justify-between bg-green-100 rounded-lg p-10">
          <h1 className="text-6xl font-signika text-black ">
            How does it work for tutors?
          </h1>
          <div>
            <div className="mt-5 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-2xl font-signika text-green-900">
                  Create a Free Account
                </h1>
                <p className="text-md font-signika text-green-600">
                Create your account in minutes with some required information.
                </p>
              </div>
            </div>
            <div className="mt-5 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-2xl font-signika text-green-900">
                Complete Your Profile
                </h1>
                <p className="text-md font-signika text-green-600">
                Complete your profile by including your personal, educational, tuition related and supporting documentation details.                </p>
              </div>
            </div>
            <div className="mt-5 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-2xl font-signika text-green-900">
                Apply to Your Desired Tuition Job
                </h1>
                <p className="text-md font-signika text-green-600">
                Check the job board everyday and apply on desirable tuition jobs which match with you the most.


                </p>
              </div>
            </div>
            <div className="mt-5 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-2xl font-signika text-green-900">
                Get Selected
                </h1>
                <p className="text-md font-signika text-green-600">
                Get shortlisted from system and selected by the guardian/student based on your provided information in profile.

                </p>
              </div>
            </div>
         
          </div>
        </div>
        <div className="relative h-[600px]">
        <img
          className="rounded-lg w-full h-full object-cover"
          src="https://i.ibb.co.com/RY6rttt/a7a2a753-df2d-44c2-ac3e-9722df717ea1.jpg"
          alt=""
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black to-green-600 opacity-60 rounded-lg"></div>

        {/* Text on top of the overlay */}
        <div className="absolute inset-0 flex flex-col justify-between items-start p-10">
         
        </div>
      </div>
        {/* <div className="w-[53%] rounded-lg">
          <img src="https://i.ibb.co.com/RY6rttt/a7a2a753-df2d-44c2-ac3e-9722df717ea1.jpg" alt=""></img>
        </div> */}
      </div>
    </div>
  );
};

export default HomeTutorContentGreen;
